module.exports = "<div class=\"qr-scrollable-tabs\">\n  <div \n    *ngFor=\"let tab of tabs\" \n    class=\"qr-tab-item\" \n    [class.active]=\"activeStatus === tab.value\"\n    (click)=\"selectTab(tab.value)\">\n    {{ tab.label }}\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/status-filter/status-filter.component.html
// module id = ../../../../../src/app/components/status-filter/status-filter.component.html
// module chunks = 3